<template>
  <b-modal
    id="import-modal"
    v-model="modal"
    hide-footer
    hide-header
    centered
  >
    <b-form @submit.prevent="importModal">
      <div class="text-right">
        <b-link @click="modal = false">
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.71152 5.5L10.8243 1.38681C10.9374 1.27358 10.9998 1.12252 11 0.961445C11 0.80028 10.9376 0.649042 10.8243 0.535994L10.4639 0.175654C10.3506 0.0621585 10.1995 0 10.0383 0C9.87729 0 9.72624 0.0621585 9.61293 0.175654L5.50018 4.28858L1.38725 0.175654C1.27412 0.0621585 1.12298 0 0.961829 0C0.800854 0 0.649715 0.0621585 0.536585 0.175654L0.176 0.535994C-0.0586667 0.770676 -0.0586667 1.15239 0.176 1.38681L4.28884 5.5L0.176 9.61302C0.0627805 9.72642 0.000447154 9.87748 0.000447154 10.0386C0.000447154 10.1996 0.0627805 10.3507 0.176 10.464L0.536496 10.8243C0.649626 10.9378 0.800854 11 0.96174 11C1.12289 11 1.27403 10.9378 1.38716 10.8243L5.50009 6.71133L9.61284 10.8243C9.72615 10.9378 9.8772 11 10.0382 11H10.0383C10.1994 11 10.3505 10.9378 10.4638 10.8243L10.8242 10.464C10.9373 10.3508 10.9997 10.1996 10.9997 10.0386C10.9997 9.87748 10.9373 9.72642 10.8242 9.6131L6.71152 5.5Z"
              fill="#6E747A"
            />
          </svg>
        </b-link>
      </div>
      <div class="mt-2 mb-5 px-5">
        <h4 class="text-center mb-5 font-weight-bold">
          Import Modal
        </h4>

        <b-form-group label="Add Share Code">
          <b-input
            v-model="hash"
            required
          />
        </b-form-group>

        <div class="d-flex justify-content-center">
          <b-btn
            variant="primary"
            type="submit"
            :disabled="loading"
          >
            Add New Modal
            <svg
              v-if="!loading"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mb-1 w-4 h-4"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.6 9.3C17.6 13.884 13.884 17.6 9.3 17.6C4.71604 17.6 1 13.884 1 9.3C1 4.71604 4.71604 1 9.3 1C13.884 1 17.6 4.71604 17.6 9.3ZM9.3 16.3C13.166 16.3 16.3 13.166 16.3 9.3C16.3 5.43401 13.166 2.3 9.3 2.3C5.43401 2.3 2.3 5.43401 2.3 9.3C2.3 13.166 5.43401 16.3 9.3 16.3Z"
                fill="white"
              />
              <path
                d="M12.9 9.53198V8.26798H10.036V5.14798H8.64398V8.26798H5.76398V9.53198H8.64398V12.78H10.036V9.53198H12.9Z"
                fill="white"
              />
            </svg>

            <b-spinner
              v-else
              class="ml-2"
              small
            />
          </b-btn>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'ImportModal',
  data () {
    return {
      loading: false,
      modal: false,
      hash: ''
    }
  },
  methods: {
    async importModal () {
      this.loading = true
      await this.$store.dispatch('modal/importModal', this.hash)
        .then(() => {
          this.$emit('modal-imported')
          this.modal = false
          this.$swal({
            icon: 'success',
            title: 'Modal Imported',
            showConfirmButton: false,
            timer: 3000
          })
        })
        .catch((err) => {
          console.log(err)
          this.$swal({
            icon: 'error',
            title: 'Something went wrong',
            text: err.message,
            showConfirmButton: false
          })
        })
        .finally(() => {
          this.loading = false
        })
      this.hash = ''
    }
  }
}
</script>
